import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
// Components
import PrimaryButton from "../primary-button";
import Heading from "../heading";
// styles
import "./style.scss";
import Input from "../input";
import IconLink from "../icon-link";

const RadioAccordion = ({ title, selectedOption, options, button, info, onChange, locationLink, input, setShowModal }) => {
  const [checked, setChecked] = useState(selectedOption);
  const [isDisabled, setIsDisabled] = useState(true);

  const handleChecked = option => {
    setChecked(option);
    onChange(option);
  };

  return (
    <div className="radio-group">
      {title && (
        <div className="radio-group-heading">
          <Heading typographyClass="type-h4" html={`<h4>${title}</h4>`} />
        </div>
      )}
      {options.map(option => (
        <div className="radio-accordion">
          <div className="radio-accordion-row">
            <RadioButton {...option} checked={checked} onClick={handleChecked} />
            <p className="tag">{option.tag}</p>
          </div>
          {checked.value === option.value && (
            <motion.div className="radio-accordion-dropdown" initial={{ height: 0 }} animate={{ height: "100%" }}>
              <p className="info">{option.info}</p>
              {option.findLocation ? (
                <div className="location-finder">
                  <IconLink {...locationLink} callback={() => setShowModal(true)} />
                  <Input classname="input" {...input} setIsDisabled={setIsDisabled} />
                  <PrimaryButton {...button} isDisabled={isDisabled} />
                </div>
              ) : (
                <PrimaryButton {...button} />
              )}
            </motion.div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RadioAccordion;

const RadioButton = ({
  value,
  label,
  description,
  checked,

  onClick = () => {}
}) => {
  const radioButtonClassList = classNames({
    checked: checked.value === value
  });

  return (
    <div className="radio-button-container" onClick={() => onClick({ label, value })}>
      <div
        className={classNames("radio-button", {
          checked: checked.value === value
        })}
      >
        <div className={radioButtonClassList} />
      </div>
      <div className="label-container">
        <p className="label title">{label}</p>
        <p className="label description">{description}</p>
      </div>
    </div>
  );
};

RadioAccordion.propTypes = {
  title: PropTypes.string,
  selectedOption: PropTypes.object,
  options: PropTypes.array,
  button: PropTypes.object,
  info: PropTypes.string,
  onChange: PropTypes.func
};

RadioButton.protoTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  checked: PropTypes.bool
};
